/** Strip internal GCP/JSON errors before showing export failures in the UI. */
export function formatExportErrorMessage(message: string): string {
  const trimmed = message.trim();
  const gcpMessage = extractGcpErrorMessage(trimmed);

  if (gcpMessage) {
    if (/project.*not found|forbidden|permission denied|access denied/i.test(gcpMessage)) {
      return 'Export storage is not configured for this environment.';
    }
    return 'Export failed. Please try again or contact support.';
  }

  if (/export storage is not configured/i.test(trimmed)) {
    return trimmed;
  }

  if (
    trimmed.length > 200
    || trimmed.includes('\n')
    || trimmed.startsWith('{')
    || /gaxios|stack/i.test(trimmed)
  ) {
    return 'Export failed. Please try again or contact support.';
  }

  return trimmed;
}

function extractGcpErrorMessage(message: string): string | null {
  if (!message.startsWith('{')) return null;
  try {
    const parsed = JSON.parse(message) as { error?: { message?: string } };
    return typeof parsed.error?.message === 'string' ? parsed.error.message : null;
  } catch {
    return null;
  }
}
